let solutionsBlock = document.querySelector('.component--solutions-overview');
let solutionsCircle = document.querySelector('.component--solutions-overview .js-solutions-circle');
let circleContentWrapper = document.querySelector('.component--solutions-overview .circle-content-wrapper');

if (solutionsBlock){

  // trigger animation of SVG lines and dots (inside SVG file) when user scrolls to section
  new Waypoint({
    element: solutionsBlock,
    handler: function(direction) {

      solutionsCircle.style.display = 'block'; // add active class to trigger circle animations
      solutionsCircle.offsetWidth; // reflow technique;
      solutionsCircle.classList.add('fade-in');

      // set correct height on rotated element
      let windowWidth = window.outerWidth;

      if (windowWidth <= 991) {
        getGraphicHeight();
      }
    },
    offset: '50%'
  })

  function getGraphicHeight() {
    let solutionsCircleWidth = solutionsCircle.getBoundingClientRect().height;
    circleContentWrapper.style.height = solutionsCircleWidth + 'px'; // extra 100 for padding;
  }

  // call getGraphicHeight FN on both window resize or device orientation change (e.g. iPad)
  window.addEventListener('resize', Drupal.debounce(getGraphicHeight, 250));
  window.addEventListener('orientationchange', getGraphicHeight);

}
